

import {GET_AdminMarksTable, UPDATE_MARKS_TABLE} from '../constants/ActionTypes'

const INIT_STATE = {
    AdminMarksTable: null,
    loading: false
};

export default (state = INIT_STATE, action) => {

    switch (action.type) {
        case GET_AdminMarksTable:
            console.log(action, 'actionnnn');
            return {
                AdminMarksTable: action.body,
                loading :false
            }
        case UPDATE_MARKS_TABLE:
            console.log(action, 'aaaaccc');
            return {
                AdminMarksTable: action.body
            }
        default:
            return state;
    }
}